import { Box, Button, Pagination, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Input from './Input'
import { useDispatch, useSelector } from 'react-redux';
import Styles from '../Config/Styles';
import { storage } from '../Config/Storage';
import { getfilteredProducts, getProducts } from '../Redux/Products/action';
import ProductDetails from './ProductDetails';
import Toastify from './Toastify';
import Loader from './Loader';
import Cashback from './Cashback';
import { useSwipeable } from 'react-swipeable';

const Products = ({ loading, setLoading }) => {
    const dispatch = useDispatch();

    // Redux states for brands and products
    const { brands } = useSelector((state) => state?.CategoriesData) || [];
    const { products } = useSelector((state) => state?.ProductsData) || [];

    // Component states
    const [page, setPage] = useState(1);
    const [id, setId] = useState();
    const [value, setValue] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [selectedFilters1, setSelectedFilters1] = useState([]);

    const pageName = storage.fetch.category_name(); // Category name for display
    let data = { page: 1 };

    /**
     * Effect to handle loading state when brands, products, or pageName changes.
     */
    useEffect(() => {
        setLoading(false);
    }, [brands, products, pageName, setLoading]);

    /**
     * Handle pagination change.
     * @param {Event} event - Pagination change event.
     * @param {number} value - Current page number.
     */
    const handleChange = (event, value) => {
        setPage(value);
        setLoading(true);
        dispatch(getProducts({ page: value }, setLoading));
    };

    /**
     * Handle search key press for product search.
     * @param {Event} e - Keyboard event.
     */

    const handlekey = (e) => {
        if (e.key === "Enter") {
            setLoading(true)
            Object.assign(data, { search: value })
            dispatch(getProducts(data, setLoading))

        }
    }

    /**
     * Open product details modal.
     * @param {string} productId - Product ID to view details.
     */
    const handleOpen = (productId) => {
        setValue('');
        setOpen(true);
        setId(productId);
    };

    /**
     * Close product details modal.
     */
    const handleClose = () => {
        setOpen(false);
        setId(null)
    };

    /**
     * Toggle brand filters.
     * @param {number} index - Index of the selected filter.
     * @param {Object} brand - Brand object.
     */
    const toggleFilter = (index, brand) => {

        setLoading(true)

        setSelectedFilters((prev) => {
            const updatedFilters = prev.includes(brand.id)
                ? prev.filter((id) => id !== brand.id) // Remove `brand.id` if already selected
                : [...prev, brand.id]; // Add `brand.id` if not selected

            // Dispatch the updated filters
            const filterData = {
                ids: updatedFilters, // Send array of IDs
                attr: "456b9334-4779-4406-b728-98c1806acd27",
            };
            dispatch(getfilteredProducts(filterData, setLoading));

            return updatedFilters; // Update state with the modified filters
        });
        setSelectedFilters1((prev) => {
            const selected = prev.includes(index)
                ? prev.filter((item) => item !== index) // Remove filter
                : [...prev, index] // Add filter
            return selected; // Update state with the modified filters
        });

    };


    return (
        <Box className="box" sx={Styles.products.box}  >
            {/* Search Bar */}
            <Box sx={Styles.products.search}>
                <Input placeholder={"Search for product..."} value={value} setValue={setValue} handlekey={handlekey} />
            </Box>

            {/* Loader */}
            <Loader open={loading} />

            {/* Product Details Modal */}
            <ProductDetails open={open} id={id} handleClose={handleClose} setLoading={setLoading} loading={loading} />

            {/* Filter by Brands */}
            <Box>
                <Typography sx={Styles.products.typo}>Filter by Brands</Typography>
                <Box sx={Styles.products.filter} className="box">
                    {brands?.map((brand, index) => (
                        <Button
                            key={index}
                            sx={{
                                ...Styles.products.filterbtn,
                                border: selectedFilters1.includes(index)
                                    ? '1px solid #0047A4'
                                    : '1px solid #E6E6E6',
                                backgroundColor: selectedFilters1.includes(index)
                                    ? '#F0F8FF'
                                    : 'white',
                            }}
                            onClick={() => toggleFilter(index, brand)}
                        >
                            {brand?.name}
                        </Button>
                    ))}
                </Box>
            </Box>

            {/* Product Results */}
            <Typography sx={{ ...Styles.products.typo, mt: 2 }}>
                Results for "{pageName}"
            </Typography>

            <Grid container spacing={2}>
                {!products?.data?.length &&
                    <Box sx={Styles.products.emptybox}>
                        <img src={require('../assets/empty.png')} width={"300px"} />
                    </Box>
                }
                {products?.data?.map((product) => (
                    <Grid item xs={6} sm={6} md={4} key={product.id}>
                        <Box sx={Styles.products.productbox}>
                            {/* Product Image */}
                            <Box sx={Styles.products.imgbox}>

                                <img
                                    src={
                                        product?.product_image
                                            ? `https://api-dev.tabta.net/assets/${product?.product_image}?cache-buster=2025-01-02T11:33:33.214Z&key=system-large-contain`
                                            : require('../assets/dummy.jpg')
                                    }
                                    style={Styles.products.img}
                                    alt={product?.name}
                                />
                            </Box>

                            {/* Product Name and Add Button */}
                            <Box
                                sx={Styles.products.btnbox}
                            >
                                {product.cashback ? <Cashback /> : <Box sx={{ height: "35px" }}></Box>}
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    sx={Styles.products.name}
                                >
                                    {product.name}
                                </Typography>
                                <Button
                                    sx={Styles.products.btn}
                                    onClick={() => handleOpen(product.id)}
                                >
                                    Add +
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            {/* Pagination */}
            {products?.pages > 1 && (
                <Box sx={Styles.products.pagination}>
                    <Pagination
                        shape="rounded"
                        count={products?.pages}
                        page={page}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Box>
            )}

            {/* Toast Notifications */}
            <Toastify />
        </Box>
    );
};

export default Products;